import React, {useState} from 'react';
import { Modal } from 'react-bootstrap';
import {concepts, User} from "fearless-common";
import {Alert, Button, getFullName} from 'fearless-common-ui';
import useApiCall from "../hooks/useApiCall";
import {backendEndpoints} from "../../libs/backendEndpoints";

/**
 * Remove the user from the group subscription by taking their seat
 * or grant a user a seat on the subsscription.
 *
 * @param user
 * @param groupId Group ID.
 * @param hasSeatCurrently True if the user currently has a seat on the group subscription
 * @param onSuccess
 */
export default function RemoveOrGrantSeatModal({ user, groupId, hasSeatCurrently, onSuccess }: {
  user: User,
  onSuccess: () => void;
  groupId: number;
  hasSeatCurrently: boolean
}) {
  const [show, setShow] = useState(false);
  const { onSubmit, isSubmitting, error, reset } = useApiCall({
    url: hasSeatCurrently ? backendEndpoints.takeSeat(groupId) : backendEndpoints.grantSeat(groupId),
    method: 'put',
  })

  const hide = () => {
    setShow(false);
    reset();
  }

  return (
    <>
      <Button className="p-0 text-sm" variant="link" onClick={() => setShow(true)}>
        {hasSeatCurrently ? 'Remove' : 'Add'}
      </Button>
      {show && (
        <Modal className="text-center" show onHide={hide} >
          <Modal.Header closeButton>
            <Modal.Title>{!hasSeatCurrently ? 'Give seat on' :  'Remove from'} {concepts.Subscription.toLowerCase()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{getFullName(user)} will be {!hasSeatCurrently ? 'given a seat on ' : 'removed from'} the subscription.</p>
          </Modal.Body>
          <Modal.Footer className="justify-content-center">
            {error && <Alert>{error}</Alert>}
            <Button
              variant="danger"
              isDoing={isSubmitting}
              onClick={(e) => {
                e.preventDefault();
                onSubmit({ user_id: user.id }).then((success) => success && onSuccess());
              }}
              type="button"
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
